import { render, staticRenderFns } from "./FoodTypeAddUpdate.vue?vue&type=template&id=1d8b905a&scoped=true"
import script from "./FoodTypeAddUpdate.vue?vue&type=script&lang=js"
export * from "./FoodTypeAddUpdate.vue?vue&type=script&lang=js"
import style0 from "./FoodTypeAddUpdate.vue?vue&type=style&index=0&id=1d8b905a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b905a",
  null
  
)

export default component.exports